import styled from 'styled-components/macro';

export const ProjectLocationsWrapper = styled.div`
    padding: 5px 15px;
    min-height: 100%;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
`;
